





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATECONTACTUSSECTION
// UPDATECONTACTUSSECTION


const UPDATECONTACTUSSECTION= createAsyncThunk(
  "updateContactUsSection/updateContactUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateContactUsSectionSlice = createSlice({
  name: "updateContactUsSectionSlice",
  initialState: {
    updateContactUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateContactUsSection: (state) => {
        state.updateContactUsSection.loading = false
        state.updateContactUsSection.error = false
        state.updateContactUsSection.data = []
        state.updateContactUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATECONTACTUSSECTION.fulfilled, (state, action) => {
      state.updateContactUsSection = {
        ...state.updateContactUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONTACTUSSECTION.pending, (state, action) => {
      state.updateContactUsSection = {
        ...state.updateContactUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONTACTUSSECTION.rejected, (state, action) => {
      state.updateContactUsSection = {
        ...state.updateContactUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateContactUsSectionAction = {
    UPDATECONTACTUSSECTION,
};

export { updateContactUsSectionAction };
export default updateContactUsSectionSlice.reducer;
export const {setInitialStateOfupdateContactUsSection} = updateContactUsSectionSlice.actions
